import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getBrochureData } from "../../../../services/event/dashboard/dashboardServices";

const BrochureCountriesChart = (props) => { 
    const { startMonth, endMonth, subDomain,filterField } = props;

  const [chartData, setChartData] = useState({
    series: [
      {
        name: "",
        data: [],
        color: "#008FFB", // Blue
      },
    ],
    options: {
      
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getBrochureData({ sub_domain: subDomain?subDomain :"", filterField: filterField,fromDate: startMonth, toDate: endMonth });
        const countries = response?.data.map((item) => item.country);
        const counts = response?.data.map((item) => parseInt(item.count));
        setChartData((prevData) => ({
          ...prevData,
          series: [{ name: "series-1", data: counts?counts:[], color: "#008FFB" }], 
          options: {
            ...prevData.options,
            chart: {
              type: "bar",
              height: "100%",
              width: "100%",
            },
            title: {
              text: `Total Brochure: ${counts.reduce(
                (a, b) => a + b,
                0
              )}`,
              align: "left",
              style: {
                fontSize: "16px",
                fontWeight: 800,
                color: "#333",
              },
            },
            xaxis: { categories: countries },
            plotOptions: {
              bar: {
                horizontal: true, // Horizontal bar chart
                borderRadius: 3,
              },
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              y: {
                formatter: (value) => Math.round(value), // Ensure integers in tooltips
              },
            },
          },
        }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [startMonth,endMonth,subDomain,filterField]);

  return (
    <>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={props.height}
      />
    </>
  );
};

export default BrochureCountriesChart;
